/** @jsxImportSource @emotion/react */

import { css } from "@emotion/react";

import { useTranslation } from "react-i18next";

import Typography from "@mui/material/Typography";

import { colors } from "@dotnet/telematics-design-system";

import { ROUTES } from "../../..";
import Button, {
  BUTTON_COLORS,
  BUTTON_SIZES,
  BUTTON_VARIANTS
} from "../../../../components/Button/Button";
import Logo from "../../../../components/Logo/Logo";
import LottieAnimation from "../../animation/LottieAnimation";
import { useStyles } from "../styles";
import { TITLES } from "../types";
import ColoredCircles from "./ColoredCircles";

interface IErrorComponentProps {
  onButtonClick: () => void;
  title: TITLES;
  animation: any;
  message?: string;
  pathname: string;
}

const ErrorComponent = ({
  onButtonClick,
  title,
  animation,
  message,
  pathname
}: IErrorComponentProps) => {
  const { t } = useTranslation();

  const {
    headerWithLogo,
    animationCSS,
    errorMainContainer,
    errorAnimatedBlock,
    errorMainTitle,
    errorDescriptionArea
  } = useStyles();

  return (
    <>
      <header css={css(headerWithLogo)}>
        <Logo />
      </header>
      <main>
        <section className="remaining-height">
          <div className="remaining-height" css={css(errorMainContainer)}>
            <div css={css(errorAnimatedBlock)}>
              <ColoredCircles />
              <div>
                {title === TITLES.Error && (
                  <div css={css(errorMainTitle)}>{t(`${title}##error`)}</div>
                )}
              </div>
              {/* animation */}
              <LottieAnimation
                data-testid="lottie"
                animationData={animation}
                loop
                css={css(animationCSS)}
              />
            </div>

            <div css={css(errorDescriptionArea)}>
              <Typography
                css={css({
                  color: colors.textDark,
                  paddingBottom: "16px"
                })}
                variant="h4"
              >
                {t(`${title}##title`)}
              </Typography>

              {message && (
                <Typography
                  css={css({
                    color: colors.gray700
                  })}
                  variant="body1Regular"
                >
                  {t(message)}
                </Typography>
              )}

              <div
                css={css({
                  paddingTop: "16px"
                })}
              >
                <Button
                  data-testid="navigation-button"
                  color={BUTTON_COLORS.Primary}
                  size={BUTTON_SIZES.Normal}
                  variant={BUTTON_VARIANTS.TextOnly}
                  onClick={onButtonClick}
                >
                  {pathname === ROUTES.Dashboard
                    ? t("Button##refresh page")
                    : t("Button##return home")}
                </Button>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default ErrorComponent;
